import { BreadcrumbsMap } from '../../components/breadcrumbs';

export const usersBreadcrumbs: BreadcrumbsMap = {
  '/users': 'Users',
};
